import { createDimensionTooltipLine } from "./dimensionTooltipLines";
import { createMesureTooltipLines } from "./measureTooltipLines";
export const createTooltipItems = (params, measures) => {
    const result = [];
    if (measures) {
        for (const param of params) {
            if (measures[param.value]) {
                result.push([param.label, measures[param.value]]);
            }
            else if (measures[param.value] === 0) {
                result.push([param.label, "0"]);
            }
        }
    }
    else {
        for (const param of params) {
            if (param.value) {
                result.push([param.label, param.value]);
            }
        }
    }
    return result;
};
export const createCompositeMeasureTooltipLines = (composite, metadata) => {
    const { dimension, measures: measure } = composite;
    const tooltipLines = [];
    if (dimension) {
        const dimensionTooltipLine = createDimensionTooltipLine(dimension, metadata.tooltipLabels[measure?.PARENT ? 2 : 1]);
        tooltipLines.push(dimensionTooltipLine);
    }
    if (measure) {
        const measureTooltipLines = createMesureTooltipLines(measure, {
            ...metadata.tooltipLabels[0], displayType: metadata.displayType, formattedFieldName: metadata.formattedFieldName, totalPercentName: metadata.totalPercentName
        });
        tooltipLines.push(...measureTooltipLines);
    }
    return tooltipLines;
};
export const generateTooltipItems = (composite, metadata) => {
    const compositTooltipLines = createCompositeMeasureTooltipLines(composite, metadata);
    const tooltip = createTooltipItems(compositTooltipLines);
    return tooltip;
};
